import HtmlElement from '../../../Elements/HtmlElement';

/**
 * File Upload
 */
const FileUpload = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		FILE_UPLOAD: '.file-upload',
		INFO: '.file-upload-info',
		INPUT: '[type="file"]'
	};

	/**
	 * File Upload
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class FileUpload extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this._$info = this.$element.find(Selector.INFO);
			this._$input = this.$element.find(Selector.INPUT);
			this._defaultText = this._$info.data('default');
			this._selectedTextSuffix = this._$info.data('selected-suffix');

			this._initialize();
		}

		_initialize() {
			const currentFiles = Array.from(this._$input.get(0).files);
			this._handleFiles(currentFiles);
			this._bindHandlers();
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			this._$input.on('change', (e) => {
				const files = Array.from(e.target.files);
				this._handleFiles(files);
			});
		}

		/**
		 * Handles the files and changes the information text
		 *
		 * @param { Array } files
		 * @return void
		 */
		_handleFiles(files) {
			this._$info.removeAttr('title');

			if (files.length > 1) {
				this._$info.html(`${files.length} ${this._selectedTextSuffix}`);

				let title = '';

				files.forEach((file) => {
					title = title += `${file.name}\n`;
				});

				this._$info.attr('title', title);
			} else if (files.length === 1) {
				this._$info.html(files[0].name);
			} else {
				this._$info.html(this._defaultText);
			}
		}
	}

	return FileUpload._getElements(Selector.FILE_UPLOAD, FileUpload);
})();

export default FileUpload;
